import React from 'react';
import classNames from 'classnames';

import {formatDate} from 'utils/datetime';

import {SCHEDULE_ITEM_TYPES} from 'ducks/tenancy';

import Alert from 'components/Alert';
import Table from 'components/Table';
import Money from 'components/Money';
import Ellipsis from 'components/Ellipsis';
import InvoiceStatusTag from 'components/InvoiceStatusTag';

import {getSyncedWithXeroIcon} from 'containers/BookingDetail/utils';

const InvoiceRow = ({invoice, handleRowClick, scheduleType}) => {
  const {invoiceDetails} = invoice;
  return (
    <Table.Row
      className={classNames('scheduleRow', {
        highlighted: invoice.highlighted
      })}
      onClick={() =>
        handleRowClick(SCHEDULE_ITEM_TYPES.INVOICE, invoice.id, scheduleType)
      }>
      <Table.Cell>{formatDate(invoice.date)}</Table.Cell>
      <Table.Cell>{formatDate(invoiceDetails.dueDate)}</Table.Cell>
      <Table.Cell className="activity">
        <div className="colab-centered">
          {invoiceDetails.hasXeroErrors && <Alert />}
          <Ellipsis>{invoice.activity}</Ellipsis>
        </div>
      </Table.Cell>
      <Table.Cell className="details">
        <Ellipsis>{invoiceDetails.description}</Ellipsis>
      </Table.Cell>
      <Table.Cell>
        <InvoiceStatusTag
          overdue={invoiceDetails.overdue}
          status={invoiceDetails.status}
        />
      </Table.Cell>
      <Table.Cell>{getSyncedWithXeroIcon(invoiceDetails.xeroId)}</Table.Cell>
      <Table.Cell className="amount">
        <Money
          amount={invoice.amount}
          balance
          className={classNames({
            strikeThrough: invoiceDetails.voided
          })}
        />
      </Table.Cell>
      <Table.Cell />
      <Table.Cell className="balance">
        <Money amount={invoice.balance} balance />
      </Table.Cell>
    </Table.Row>
  );
};

export default InvoiceRow;
